//import './styles/fonts.css';
import './styles/index.css';
import 'swiper/css';

import './js/anims';
import './js/menu';
import './js/no-widows';
import './js/topbar';
import './js/smoothscroll';

if (document.querySelector("[data-accordion]")) {
  import('./js/accordion').then(({ initAccordion }) => {
    initAccordion();
  });
}

if (document.querySelector("[data-scroll-nav]")) {
  import('./js/scroll-nav').then(({ initScrollNav }) => {
    initScrollNav();
  });
}

if (document.querySelectorAll(".js-roller").length > 0) {
  import('./js/roller').then(({ initRoller }) => {
    initRoller();
  });
}

if (document.querySelectorAll(".js-simple-carousel").length > 0) {
  import('./js/swiper').then(({ initSwiper }) => {
    initSwiper();
  });
}

if (document.querySelector("#timeline")) {
  import('./js/timeline').then(({ initTimeline }) => {
    initTimeline();
  });
}

const emailLinks = document.querySelectorAll('.email-link');

if (emailLinks.length && window.emailConfig) {
  const { user, domain } = window.emailConfig;
  const email = `${user}@${domain}`;

  emailLinks.forEach(link => {
    link.href = `mailto:${email}`;
    const name = link.querySelector('.name');

    if (name) {
      name.textContent = email;
    }

    link.setAttribute(
      'aria-label',
      `Napisz wiadomość na adres ${email}`
    );
  });
}



const contactForm = document.querySelector('.wpcf7-form');

if (contactForm) {
  document.addEventListener('wpcf7mailsent', function (event) {
    const form = event.target;

    if (!form.classList.contains('wpcf7-form')) return;

    const response = form.querySelector('.wpcf7-response-output');

    if (!response) return;
    const text = event.detail.apiResponse.message?.trim();
    if (!text) return;

    const parts = text.match(/^(.+?\.)\s*(.*)$/);

    if (!parts) return;

    setTimeout(() => {
      response.innerHTML = `
                <p class="text-3xl">${parts[1]}</p>
                <p class="text-lg">${parts[2]}</p>
            `;
    });
  });
}